import { Button } from '#/components/Button/Button';
import { useEnvironment } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { scrollToTop } from '#/utils/scroll';

export function SearchButton() {
  const { i18n } = useI18n();

  const { environment } = useEnvironment();

  return (
    <Button
      type="submit"
      variant="primary"
      icon={{ name: 'search' }}
      fullWidth
      qaId="search-button"
      data-ready={Boolean(environment)}
      onClick={scrollToTop}
    >
      {i18n('Search')}
    </Button>
  );
}
